import { useOnlineStatus } from '@core/lib/hooks/useOnlineStatus';

/**
 * A persistent, non-dismissible strip shown while the device is offline.
 *
 * Sits at the top of the AppShell rather than inside a page so it survives
 * navigation, and it is `role="status"` (polite) not `alert`: going offline is
 * worth telling a screen-reader user about, but not worth interrupting them
 * mid-sentence for.
 *
 * The copy promises progress is safe, which is a promise the router keeps — every
 * checkout step is a URL, so a reconnect resumes exactly where the user was.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 flex items-center justify-center gap-2 bg-warning-bg px-4 py-2 text-center text-sm font-medium text-warning border-b border-warning-border"
    >
      <span aria-hidden="true">📡</span>
      <span>You&rsquo;re offline. Your progress is saved &mdash; reconnect to continue.</span>
    </div>
  );
}
